<template>
  <div class="play-container">
    <div id="container" ref="container" class="fullscreen"></div>
  </div>
</template>
<script>

import _ from 'lodash'
import { PLAYER_OPTIONS, PLAYER_PACKAGE_TYPE, playerDelegate, PlayerType } from '@/common/utils/scalable.player'
import { ATTR_BY_PLAYER_TYPE, PLAYER_TYPE } from '@/common/resources/player.const'
import { PlayerInterface } from '@/common/utils/player.interface'

export default {
  name: 'MainPlayer',
  props: {
    contentInfo: {
      type: Object
    },
    currentSection: {
      type: String
    },
    autoPlay: {
      type: Boolean,
      default: true
    }
  },
  components: {},
  methods: {
    // 플레이어 초기화
    playerInit: async function () {
      if (!PlayerInterface.isCreatedPlayerInstance()) {
        console.log('not created player yet')
        return false
      }
      // PlayerInterface.setFullScreen()
      await PlayerInterface.setUserInfo()
      PlayerInterface.unload()
      await PlayerInterface.load(this.contentType, this.contentId, this.autoPlay ? { isAutoPlay: true } : null)
    }
  },
  computed: {
    contentType () {
      let _contentType = this.currentSection
      switch (this.currentSection) {
        case 'vod':
          _contentType = this.contentInfo.type === 'onair' ? PLAYER_TYPE.ONAIRVOD : PLAYER_TYPE.VOD
          break
        case 'baseball':
          _contentType = 'baseball'
          break
      }
      return _contentType
    },
    contentId () {
      return _.get(this.contentInfo, ATTR_BY_PLAYER_TYPE[this.currentSection].id, null)
    }
  },
  created () {
    // this.actionButtonSetting()
  },
  mounted () {
    let options = {}
    options[PLAYER_OPTIONS.IS_SEPARATE_UI] = true
    options[PLAYER_OPTIONS.IS_FADEIN_EFFECT] = true
    playerDelegate(this, this.$refs.container, PlayerType.MAIN, PLAYER_PACKAGE_TYPE.SET_PC, options)
  },
  watch: {
    contentInfo () {
      // 플레이어 재진입
      this.playerInit()
    }
  },
  beforeDestroy () {
    PlayerInterface.destructor()
  }
}
</script>
<style>
.fullscreen{
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
</style>
